

import React from 'react';

import { Container } from '@mui/material';
import Latex  from 'react-latex-next';
function ExamPaperGenerate() {
  function convertToLatex(questionPaperData) {
    let latex = `\\documentclass{article}\n\\usepackage{amsmath}\n\\usepackage{amssymb}\n\\usepackage{graphicx}\n\n`;
    latex += `\\title{${questionPaperData.title}}\n\\author{${questionPaperData.subject}}\n\n`;
    latex += `\\begin{document}\n\n`;
    latex += `\\maketitle\n\n`;
  
    questionPaperData.sections.forEach((section) => {
      latex += `\\section*{${section.sectionTitle}}\n`;
      latex += `\\textbf{Time Allowed:} ${section.timeAllowed} \\\\\n`;
      latex += `\\textbf{Total Marks:} ${section.totalMarks} \\\\\n`;
      latex += `\\textbf{Instructions:} ${section.instructions} \\\\\n\n`;
  
      section.questions.forEach((question) => {
        latex += `\\begin{enumerate}\n`;
        latex += `\\item \\textbf{${question.question}}\n`;
  
        if (question.parts) {
          latex += `\\begin{enumerate}\n`;
          question.parts.forEach((part) => {
            latex += `\\item ${part.question}\n`;
            if (part.options) {
              latex += `\\begin{itemize}\n`;
              part.options.forEach((option) => {
                latex += `\\item ${option.option}: ${option.text}\n`;
              });
              latex += `\\end{itemize}\n`;
            }
          });
          latex += `\\end{enumerate}\n`;
        }
  
        latex += `\\end{enumerate}\n\n`;
      });
    });
  
    latex += `\\end{document}\n`;
    return latex;
  }
  const latexOutput = convertToLatex(questionPaperDatd);
  console.log(latexOutput);
  return (
    <Container >
     <Latex>{latexOutput}</Latex>hello
    </Container>
  );
}

export default ExamPaperGenerate;
